module.exports = __webpack_public_path__ + "static/img/business77.98fb384.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business77.jpg
// module id = jCB2
// module chunks = 9